import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import { AppContext, UserContext, EMPTY_STRING } from 'commons-ui';
import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../utils/formConfig';

const useEdit = () => {
	const { user } = useContext(UserContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { showAlert } = useContext(AppContext);
	const { updateMessageCenterCard, deHydrateData, hydrateData, getMessageCenterCardCategoriesOption } = useService();
	const location = useLocation();
	const rowData = deHydrateData(_get(location, ['state', 'rowData']));
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.category].setRenderProps({ getOptions: getMessageCenterCardCategoriesOption });

	const handleFormSubmit = async (updatedData: any) => {
		setShowLoader(true);
		try {
			const result = await updateMessageCenterCard(
				hydrateData({
					...updatedData,
					category: rowData.category,
					email: user?.email || EMPTY_STRING,
					isActiveUpdated: updatedData.isActive !== rowData.isActive
				})
			);
			if (!_isNil(result.data.error) || !result.data.success) {
				throw result;
			}
			setShowLoader(false);
			history.goBack();
			showAlert('Message center card edited successfully', { type: 'success' });
		} catch (err: any) {
			showAlert(err.data?.error ?? 'Error while editing this message center card', { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { rowData, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEdit;
